

import React, { useEffect, useRef, useState } from "react";
import { UploadFileIcon } from "../../../../assets/images";
import InfiniteLoader from "../../../commons/InfiniteLoader/InfiniteLoader";
import { TrashIcon } from "../../../Icon";
import { connect } from "react-redux";
import { getTokenGenerateForDownloadAction, resetSasTokenForDownloadFile } from "../../../../redux/stcoTools";
import { GetGenerateSasTokenPayloadType } from "../../../../commonTypes/stcoToolsType";
import { RootState } from "../../../../redux/rootReducers";

type AppProps = {
  uploadFiles: any
  files: any;
  handleDeleteUploadedFile: (data: any) => void;
  uploadFetching: boolean;
  handleFileChange:(data:React.ChangeEvent<HTMLInputElement>)=>void;
  fileInputRef:any
  handleFileClick:()=>void;
  sasTokenForDownloadFile:string;
  dispatchGetTokenGenerateForDownloadAction:(data:GetGenerateSasTokenPayloadType)=>void;
  dispatchResetSasTokenForDownloadFile:()=>void;
  token: string | null;
  fileUploadFetching:boolean;

};
const HiringCheckListAttachmentUpload = ({
  uploadFiles,
  files,
  handleDeleteUploadedFile,
  uploadFetching,
  handleFileChange,
  fileInputRef,
  handleFileClick,
  sasTokenForDownloadFile,
  dispatchGetTokenGenerateForDownloadAction,
  dispatchResetSasTokenForDownloadFile,
  token,
  fileUploadFetching
  

}: AppProps) => {
  const [fileName , setFileName] = useState("")
    let isAutoDownload = useRef<boolean>(false);
  

  useEffect(()=>{
    dispatchResetSasTokenForDownloadFile();
  },[])

  const downloadBlobFile = async (file: any) => {
    setFileName(file?.file_name)
    let finalData = {
      fileUrl: file?.file_url,
      token,
      containerType:2

    };
    dispatchGetTokenGenerateForDownloadAction(finalData);
  };

  useEffect(() => {
    const downloadFile = async () => {
      if (sasTokenForDownloadFile) {
        try {
          const response = await fetch(sasTokenForDownloadFile);
          if (!response.ok) {
            throw new Error("Failed to fetch file");
          }
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = fileName || "downloadFile";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
          dispatchResetSasTokenForDownloadFile();
          isAutoDownload.current = false;
        } catch (error) {}
      }
    };
    downloadFile();
  }, [sasTokenForDownloadFile]);
  return (
    <>
      <div className="mt-3 p-0 mb-2">
        <div
          className="dropzone drop-area-single text-center"
          style={{
            cursor: "pointer",
            borderRadius: "8px",
            alignItems: "flex-end",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <h4 className="text-center">
            <span
              style={{
                color: "#dd4433",
              }}
            >
              <img
                src={UploadFileIcon}
                style={{ width: "26px", marginRight: "-38px" }}
                alt="upload"
                className=""
                onClick={(e: any) => {
                  e.stopPropagation();
                }}
              />
              <label
                htmlFor="file-upload"
                style={{
                  color: "#dd4433",
                  paddingLeft: "2px",
                  cursor: "pointer",
                  width: "133px",
                  padding: "10px",
                  border: "1px solid #dd4433",
                  borderRadius: "5px",
                  textAlign: "end",
                }}
                className="btn-outline"
                onClick={handleFileClick}

              >
                Attach File
              </label>

            
                <input
              type="file"
              disabled={fileUploadFetching}
              style={{ display: "none" }}
              ref={fileInputRef}
              onChange={handleFileChange}
              accept="image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, 
                        application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"

            />
            </span>
          </h4>
          <span className="ml-2" 
        >
          {" "}
          {fileUploadFetching ? (
            <div style={{ position: "relative" }}>{<InfiniteLoader />}</div>
          ) : (
            ""
          )}
        </span>
        </div>
      

        <div className="pointer" 
        >
        {uploadFiles?.length > 0
          ? uploadFiles?.map((file: any, index: any) => (
              <div key={index} className="d-flex flex-row align-items-center">
                <a
                 href="#"
                  target="_blank"
                  onClick={(e) => {
                    e.preventDefault();
                    downloadBlobFile(file);
                  }}
                  className="uploaded_file_name"
                >
                  {file?.file_name}
                </a>
                <div
                  className="ml-2"
                  onClick={() => handleDeleteUploadedFile(index)}
                >
                  <TrashIcon />
                </div>
              </div>
            ))
          : ""}
      </div>
      </div>
    
    </>
  );
};


const mapStateToProps = (state: RootState) => ({

  sasTokenForDownloadFile: state.stcoTools.sasTokenForDownloadFile,
  token: state.auth.token,
  fileUploadFetching:state.stcoTools.fileUploadFetching,


 
});

const mapDispatchToProps = (dispatch: any) => ({

  dispatchGetTokenGenerateForDownloadAction: (data: GetGenerateSasTokenPayloadType) =>
    dispatch(getTokenGenerateForDownloadAction(data)),
  dispatchResetSasTokenForDownloadFile: () =>
    dispatch(resetSasTokenForDownloadFile()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HiringCheckListAttachmentUpload);